import React, { JSX } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuth } from "../hooks/auth";
import { Role } from "../types/auth";

export const RequireRole = ({ allowedRoles }: { allowedRoles: Role[] }) => {
  const { user } = useAuth()!;
  
  if(!user)
    return <Navigate to="/login" replace />;

  // console.log('USER ROLE IN REQ AUTH', user, allowedRoles);

  if(!allowedRoles.includes(user.role)) 
    return <div>You do not have permission to view this page</div>

  return  <Outlet/>;
};
